<div class="project-pagebuilder pagebuilder-promo"
     data-content-type="project_promo"
     data-appearance="default"
     data-element="main">
<!-- data-enable-parallax="0" data-parallax-speed="0.5" data-background-images="{}"
     data-background-type="image" data-video-loop="true" data-video-play-only-visible="true"
     data-video-lazy-load="true" data-video-fallback-src="" data-element="inner"
     data-pb-style="RLHKSCX" -->

<a [routerLink]="linkUrl" class="block text-center" data-link-type="category" data-element="link">
    <span class="text text-xl font-serif text-gray-800 mb-2" data-element="text1">
      <p>{{ title1 }}</p>
    </span>
  <span class="text text-2xl font-serif text-gray-800 mb-2" data-element="text2" data-pb-style="BFW66OM">
      <p [innerHTML]="title2"></p>
    </span>
  <span class="text text-xl font-serif text-gray-800" data-element="text3">
      <p>{{ title3 }}</p>
    </span>
</a>
</div>
